<div *ngIf="showSpinner" class="spinner">
    <!-- Add your spinner HTML and styling here -->
    <i class="fas fa-spinner fa-spin fa-3x"></i>
    <p>Loading...</p>
  </div>
  